import React from 'react';

import { useSOListErrorLang } from './hooks';

import makeClasses from './SOListError.style';

interface Props {
  onRetry: () => void;
  variant?: 'list' | 'detail';
}

export function SOListError({ onRetry, variant = 'list' }: Props) {
  const _classes = makeClasses();
  const lang = useSOListErrorLang(variant);

  return (
    <div className={_classes.errorState} role='alert'>
      <h3 className={_classes.errorTitle}>{lang.errorTitle}</h3>
      <p className={_classes.errorDescription}>{lang.errorDescription}</p>
      <button type='button' className={_classes.retryButton} onClick={onRetry}>
        {lang.errorRetry}
      </button>
    </div>
  );
}
